"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FormattedTextField;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _TextField = _interopRequireDefault(require("../TextField"));
var _excluded = ["label", "labelKey"];
function FormattedTextField(_ref) {
  var label = _ref.label,
    labelKey = _ref.labelKey,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var _useIntl = (0, _reactIntl.useIntl)(),
    formatMessage = _useIntl.formatMessage;
  return /*#__PURE__*/_react.default.createElement(_TextField.default, (0, _extends2.default)({
    label: label || formatMessage({
      id: labelKey
    })
  }, props));
}